module.exports = __webpack_public_path__ + "static/media/small-check-ic-white.fdb4910a.svg";